__turbopack_context__.v({
  "canvasContainer": "HeroSection-module__3qmODq__canvasContainer",
  "caption": "HeroSection-module__3qmODq__caption",
  "ctaContainer": "HeroSection-module__3qmODq__ctaContainer",
  "mainContent": "HeroSection-module__3qmODq__mainContent",
  "primary": "HeroSection-module__3qmODq__primary",
  "root": "HeroSection-module__3qmODq__root",
});
